import React from 'react';
import IconsUrl from '../../assets/images/icons.svg';

const DokanIcons = ({ icon, size = 4, styleClasses }) => (
    <svg className={`icon h-${size} w-${size} ${styleClasses}`}>
        <use xlinkHref={`${IconsUrl}${icon}`} />
    </svg>
);
export default DokanIcons;
